@if (options$) {
    <wdx-multi-select
        [formControlNameOrIndex]="formControlNameOrIndex"
        [options]="options$ | ngrxPush"
        [multiple]="multiple"
    ></wdx-multi-select>
}
